import { DocumentPage, type DocumentSection } from "@/pages/DocumentPage";

const deleteAccountSections: DocumentSection[] = [
  {
    title: "계정 삭제 방법",
    body:
      '1. 앱 내 설정 메뉴에서 회원 탈퇴 기능을 이용하거나\n2. 아래 이메일로 삭제 요청을 보낼 수 있습니다.\n\n이메일: devggyul@gmail.com\n요청 시 가입된 이메일과 함께 "계정 삭제 요청"이라고 작성해 주세요.',
  },
  {
    title: "삭제되는 정보",
    items: [
      "회원 설정, 알림, FCM 토큰 등 계정 이용을 위한 설정 정보",
      "거래소 API credential, 포트폴리오, 포지션, 자산 스냅샷 등 자산 관리 데이터",
      "AI 채팅 세션, 메시지, 요약, 실행 로그 등 AI 기능 이용 기록",
      "탈퇴 회원이 누른 게시글/댓글 좋아요 및 뉴스 반응 등 개인 상호작용 기록",
    ],
  },
  {
    title: "보존되는 정보",
    items: [
      "Member row는 FK 보호를 위해 물리 삭제하지 않고 비활성화하며, 로그인 식별자와 프로필 정보는 익명 값으로 덮어씁니다.",
      "커뮤니티 게시글과 댓글은 대화 맥락 유지를 위해 보존되며, 작성자는 익명화된 탈퇴 회원으로 표시됩니다.",
      "다른 회원이 탈퇴 회원의 게시글/댓글에 남긴 좋아요와 댓글은 해당 회원의 공개 상호작용 데이터로 보존됩니다.",
      "접속 로그, 오류 로그, 배치/큐 처리 이력 등 운영 로그는 보안과 서비스 안정성을 위해 최대 30일간 보관 후 삭제될 수 있습니다.",
    ],
  },
  {
    title: "재가입",
    body: "탈퇴 시 기존 소셜 로그인 식별자를 익명 값으로 변경하므로 같은 소셜 계정으로 다시 가입할 수 있습니다.",
  },
];

export function DeleteAccountPage() {
  return (
    <DocumentPage
      eyebrow="Delete Account"
      title="계정 삭제 안내"
      description={'본 페이지는 “앤트(Ant)” 앱의 계정 삭제 안내 페이지입니다.\n\n현재 로그인한 회원은 앱 내 설정에서 탈퇴할 수 있으며, 탈퇴 처리 시 계정과 연결된 주요 이용 데이터가 삭제 또는 익명화됩니다.'}
      sections={deleteAccountSections}
    />
  );
}
